import React from "react";
import PropTypes from 'prop-types';
import ScopeTagSelection from './scope_tag_selection';
import ScopeLabelSelection from './scope_label_selection';

function TriggerSelection({ ruleType, updateScope }) {
  if (ruleType.includes("Rule::Tag")) {
    return <ScopeTagSelection updateScope={updateScope} />;
  }
  if (ruleType.includes("Rule::Label")) {
    return <ScopeLabelSelection updateScope={updateScope} />;
  }
}

TriggerSelection.propTypes = {
  ruleType: PropTypes.string.isRequired,
  updateScope: PropTypes.func.isRequired
};

export default TriggerSelection;
